import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'billing-info'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
})
  AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 23,
  header: $vm => $vm.$t(`general.menu_settings`),
  text($vm) {
    return $vm.$t(`account.billing`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-credit-card',
  permission: 'administer',
})

messageGroups.push('attributes')
messageGroups.push('billing_info')
